import { getRouteOptimizationHourUtc } from '../constants/scheduling'

/**
 * This function asks the question: "Will route optimization have already
 * occurred for the day represented by the given timestamp?" It more simply
 * compares the timestamp to the time when we run RO and returns true if RO
 * will have already occurred.
 *
 * !This function is duplicated at 'app/utils/date/is-day-optimized.ts'.
 * !KEEP THEM IN SYNC
 * @param timeToCheckIfRouteOptimizationOccurred
 * @returns
 */
function isDayOptimized(
  timeToCheckIfRouteOptimizationOccurred: number = Date.now(),
): boolean {
  /**
   * Determines if the given timestamp (in milliseconds) is "optimized".
   * A day becomes optimized at 14:00 INDIANA_INDIANAPOLIS on the previous day.
   */

  const givenDate = new Date(timeToCheckIfRouteOptimizationOccurred)

  // Get the UTC date components
  const year = givenDate.getUTCFullYear()
  const month = givenDate.getUTCMonth()
  const day = givenDate.getUTCDate()

  // Create a Date object for the given day at 00:00 UTC
  const targetDate = new Date(Date.UTC(year, month, day))

  const routeOptimizationHourUtc = getRouteOptimizationHourUtc()

  // Calculate the "optimized" threshold: Previous day at 14:00 INDIANA_INDIANAPOLIS time
  const optimizedStart = new Date(targetDate)
  optimizedStart.setUTCDate(targetDate.getUTCDate() - 1)
  optimizedStart.setUTCHours(routeOptimizationHourUtc, 0, 0, 0)

  // Get the current UTC time
  const now = new Date()

  const isOptimized = now >= optimizedStart

  // Return true if the current time is past the optimized threshold
  return isOptimized
}

export default isDayOptimized
